import UpdatePersonalInfoModal from "./UpdatePersonalInfoModal";

export default UpdatePersonalInfoModal;